<template>
  <div
    class="z-50 fixed top-0 left-0 w-full h-10 bg-red-500 flex justify-center"
    title="You are impersonating a user"
    description="You are impersonating a user, click the button below to stop impersonation"
  >
    <div class="flex justify-between items-center w-2/3">
      <span class="text-white font-bold text-sm"
      >⚠️ {{ $t("components.aImpersonatingBanner.text") }} ⚠️</span
      >
      <UButton
        class="!ring-gray-300 !text-gray-900 !bg-white"
        trailing-icon="i-fluent:arrow-right-24-filled"
        variant="solid"
        color="white"
        @click="stopImpersonation"
      >
        {{ $t("components.aImpersonatingBanner.stop") }}
      </UButton>
    </div>
  </div>
</template>

<script setup lang="ts">
const { stopImpersonation } = useImpersonate()
</script>
